import { createReducer } from "@reduxjs/toolkit";
import { deleteExternalTeacher, resetDeleteExternalTeacher } from "./delete-external-teacher";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const deleteExternalTeacherReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(deleteExternalTeacher.fulfilled, state => {
      return { ...state, processing: "success" };
    })
    .addCase(deleteExternalTeacher.pending, state => {
      return { ...state, processing: "pending" };
    })
    .addCase(deleteExternalTeacher.rejected, state => {
      return { ...state, processing: "failed" };
    })
    .addCase(resetDeleteExternalTeacher, () => {
      return initialState;
    });
});
